// extracted by mini-css-extract-plugin
export var dividerLine = "_65-3";
export var itemImage = "_65-9";
export var lightDivider = "_65-4";
export var modalContent = "_65-5";
export var modalContentCompact = "_65-6";
export var productCard = "_65-a";
export var productImage = "_65-b";
export var productImageCompact = "_65-7";
export var productImagePlaceholder = "_65-c";
export var productImagePlaceholderCompact = "_65-8";
export var progressBarBackground = "_65-1";
export var progressBarContainer = "_65-0";
export var progressBarFill = "_65-2";